export default __webpack_public_path__ + "vladp@2x.16ca10c4.jpg";